import { useQuery, } from "@tanstack/react-query";
import { QRButtonView, } from "./QRButtonView.tsx";
import { limitPaymentCards, } from "../../../../api";

export function QRButtonDefault() {
  const paymentCardsQuery = useQuery(limitPaymentCards(),);
  const showButton = paymentCardsQuery.isSuccess && paymentCardsQuery.data.length > 0;

  return (
    <QRButtonView showButton={showButton} />
  );
}
